/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import axios from "axios";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
const hostname = window.location.hostname
// const isRCA = hostname === "newsstar-rca.radio.cloud" || hostname === "newsstar-rca-dev.radio.cloud"

// let clientId = '3027bba6-b35d-4d29-acdc-f7ed6d169bf1';
// let tenantId = "abf37986-e881-44c1-bca8-6ddeda3b235e"
let clientId, tenantId

// if (isRCA) {
//     clientId = "28600912-7d1a-4002-bc02-4861165abd3f"
//     tenantId = "709aab84-9299-472e-ac7c-42c271302054"
// }

const url = 'https://f68x14lp60.execute-api.eu-central-1.amazonaws.com/v1/getClientAuth';
const apiKey = 'KRkIoMmbtw3LWgTErKy8V1M15gQsyNvq82IRi1W9';

const clientIdSto = localStorage?.getItem('clientId') || ""
const tenantIdIdSto = localStorage?.getItem('tenantId') || ""

const getmsalConfig =  async () => {
    if (hostname !== 'localhost' && !clientIdSto) {
        await axios.get(url, {
            headers: {
              'X-Api-Key': apiKey
            }
          })
          .then(response => {
            const res = response.data
            if (res.clientId) {
                clientId = res.clientId
                tenantId = res.tenantId
                localStorage.setItem("clientId", res.clientId)
                localStorage.setItem("tenantId", res.tenantId)
            }
          })
          .catch(error => {
            console.error('Error making API call:', error);
        });
    }

    if (clientIdSto) {
        clientId = clientIdSto;
        tenantId = tenantIdIdSto;
    }

    const result = { 
        auth: {
            clientId, // This is the ONLY mandatory field that you need to supply.
            // authority: `https://login.microsoftonline.com/${tenantId}`, // Defaults to "https://login.microsoftonline.com/common"
            authority: `https://login.microsoftonline.com/common`, // Defaults to "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"
            redirectUri: '/', // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
            postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
            navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
        },
        cache: {
            cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        },
        system: {
            loggerOptions: {
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            return;
                        case LogLevel.Info:
                            // console.info(message);
                            return;
                        case LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            return;
                        default:
                            return;
                    }
                },
            },
        },
    }
    return result;
}

export const msalConfig = await getmsalConfig()

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["openid", "profile", "User.Read", "User.ReadBasic.All"]
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
    scopes: ["openid", "profile", "User.Read", "User.ReadBasic.All"],
    loginHint: "example@domain.net"
};